import { render, staticRenderFns } from "./level2IdSelect.vue?vue&type=template&id=59243151&"
import script from "./level2IdSelect.vue?vue&type=script&lang=js&"
export * from "./level2IdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports